module.exports = __webpack_public_path__ + "img/1571973643.17efd9a2.jpg";